import { api } from "@/lib/orgApi";

export async function listPatientAllergies(patientId, { includeInactive = false } = {}) {
  if (!patientId) {
    return { items: [], review: null, catalogs: null, noKnownAllergies: false };
  }
  const params = {};
  if (includeInactive) params.includeInactive = true;
  const { data } = await api.get(`/patients/${encodeURIComponent(patientId)}/allergies`, {
    params,
  });
  return {
    items: data.items || [],
    review: data.review || null,
    catalogs: data.catalogs || null,
    noKnownAllergies: !!data.noKnownAllergies,
  };
}

export async function createPatientAllergy(patientId, payload) {
  const { data } = await api.post(
    `/patients/${encodeURIComponent(patientId)}/allergies`,
    payload,
  );
  return data;
}

export async function updatePatientAllergy(itemId, payload) {
  const { data } = await api.put(`/allergies/${encodeURIComponent(itemId)}`, payload);
  return data;
}

export async function removePatientAllergy(itemId) {
  const { data } = await api.delete(`/allergies/${encodeURIComponent(itemId)}`);
  return data;
}

export async function reviewPatientAllergies(patientId) {
  const { data } = await api.post(
    `/patients/${encodeURIComponent(patientId)}/allergies/review`,
  );
  return data;
}

export async function recordNoKnownAllergies(patientId) {
  const { data } = await api.post(
    `/patients/${encodeURIComponent(patientId)}/allergies/no-known`,
  );
  return data;
}

export async function getAllergyCatalogs() {
  const { data } = await api.get("/allergies/catalogs");
  return data;
}
